module.exports = __webpack_public_path__ + "static/media/licenta26.4b15d67c.png";